module.exports = "\n\n<iframe #faqsiframe src=\"web/FAQ.html\" (load)=\"changeLink(faqsiframe);\"></iframe>"